<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title"> Associated {{type | uppercase}} </h4>
    <button type="button" class="close text-white" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" id="modal-body">
    <div class="common-section">
      <div class="common-table">
        <div class="extra-box" *ngIf="associatedData.length <= 0">
          No Associated {{type | uppercase}}
        </div>
        <table class="table list-table-design table-sm" *ngIf="associatedData.length > 0">
          <thead class="thead-dark">
            <tr>
              <th>Name</th>
              <th>Project</th>
              <!-- <th>Created By</th>
              <th>Updated By</th>
              <th>Updated On</th>
              <th>Testcase Type</th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="associatedData.length <= 0">
              <td colspan="4">No data found</td>
            </tr>
            <tr *ngFor="let item of associatedData; let index = index">
              <td class="text-truncate" style="max-width: 9rem" title="{{ item.endPointName }}">
                <a class="mr-2" target="_blank" [routerLink]="[type, item.id]"> <i class="fas fa-link"></i> </a>
                <span class="clickable">{{ item.name }}</span>
              </td>
              <td>
                {{item.project.name}}
              </td>
              <!-- <td>{{ item.createdBy?.displayName }}</td>
              <td>{{ item.updatedBy?.displayName }}</td>
              <td>{{ item.updatedOn }}</td>
              <td>
                <div *ngIf="item.nonFunctional">NON FUNCTIONAL</div>
                <div *ngIf="!item.nonFunctional">FUNCTIONAL</div>
                <div *ngIf="item.desktopTestCase">DESKTOP</div>
                <div *ngIf="item.hybridTestCase">HYBRID</div>
                <div *ngIf="item.mobileTestCase">MOBILE</div>
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer confirm-footer">
      <button class="btn btn-warning btn-sm" type="button" (click)="close()"><i class="fas fa-times-circle mr-1"></i> Close</button>
  </div>
